<div
  class="relative shrink-0"
  [style.width.px]="size()"
  [style.height.px]="size()"
>
  <svg viewBox="0 0 100 100" class="h-full w-full -rotate-90">
    <circle
      cx="50"
      cy="50"
      [attr.r]="radius()"
      fill="none"
      stroke="currentColor"
      class="text-greyscale-200"
      [attr.stroke-width]="strokeWidth()"
    />
    <circle
      cx="50"
      cy="50"
      [attr.r]="radius()"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      class="text-primary-500 transition-all duration-700 ease-out"
      [attr.stroke-width]="strokeWidth()"
      [attr.stroke-dasharray]="circumference()"
      [attr.stroke-dashoffset]="dashOffset()"
    />
  </svg>

  <div class="absolute inset-0 flex items-center justify-center">
    <span
      class="font-semibold leading-none text-greyscale-950"
      [style.font-size.px]="labelSize()"
    >
      {{ percent() }}%
    </span>
  </div>
</div>
